module.exports = __webpack_public_path__ + "static/media/attachment-clip.28731f38.svg";